import { Tag, Text } from '@nimbus-ds/components';
import { InteractiveList } from '@nimbus-ds/patterns';
import { LocationResponseDto } from '@tiendanube/common';
import { Stack } from 'commons/components';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';
import './LocationCheckboxItem.scss';

interface LocationCheckboxItemProps {
  location: LocationResponseDto;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
  disabledMessage?: string;
}

function LocationCheckboxItem({
  location,
  checked,
  onChange,
  disabled = false,
  disabledMessage,
}: Readonly<LocationCheckboxItemProps>): JSX.Element {
  const t = useTranslationShipping();

  const handleChange = () => {
    if (!disabled) {
      onChange();
    }
  };

  return (
    <div
      style={{
        backgroundColor: disabled
          ? 'var(--nimbus-colors-neutral-surface)'
          : undefined,
        cursor: disabled ? 'not-allowed' : 'default',
      }}
    >
      <InteractiveList.CheckboxItem
        title={location.name}
        showTitle={false}
        checkbox={{
          name: location.id,
          checked,
          onChange: handleChange,
          disabled: disabled,
        }}
      >
        <Stack column spacing="tight" align="flex-start">
          <Text
            fontSize="base"
            color={disabled ? 'neutral-textDisabled' : 'neutral-textHigh'}
          >
            {location.name}
          </Text>
          <Text
            fontSize="caption"
            color={disabled ? 'neutral-textDisabled' : 'neutral-textHigh'}
          >
            {location.address}
          </Text>
          {location.tags && location.tags.length > 0 && (
            <Stack spacing="tight" justify="flex-start" align="flex-start" wrap>
              {location.tags.map((tag) => (
                <div
                  className={
                    disabled ? 'location-checkbox-item-tag-disabled' : undefined
                  }
                  key={tag}
                >
                  <Tag appearance="neutral">
                    {t(`locations.card.tag.${tag}`)}
                  </Tag>
                </div>
              ))}
            </Stack>
          )}
          {disabled && !!disabledMessage && (
            <Text fontSize="caption" color="danger-textHigh">
              {disabledMessage}
            </Text>
          )}
        </Stack>
      </InteractiveList.CheckboxItem>
    </div>
  );
}

export default LocationCheckboxItem;
